import { BaseModel } from './BaseModel';

export default class Attribute extends BaseModel {
  defaults() {
    return {
      id: null,
      name: null,
      type: null,
      maximum: 0,
      required: 0,
      import_key: '',
      brand_id: 0,
      attribute_items: [],
      brand: null,
    };
  }

  options() {
    return {
      identifier: 'id',
    };
  }

  // Route configuration
  routes() {
    const include = ['attributeItems', 'brand'];
    return {
      fetch: `/attributes/{id}?with=${include.join(',')}`,
      save: `/attributes/{id}?with=${include.join(',')}`,
      create: `/attributes`,
    };
  }

  // Override onFetchSuccess
  onFetchSuccess(response) {
    const data = response.getData();

    if (!data || !data.success) {
      throw this.createResponseError('Invalid attribute');
    }

    this.assign(data.data);
    this.set(this, 'fatal', false);
    this.set(this, 'loading', false);
    this.emit('fetch', {
      error: null,
    });
  }
}
